import { render, staticRenderFns } from "./onSiteElectricity.vue?vue&type=template&id=545912d2&scoped=true&"
import script from "./onSiteElectricity.vue?vue&type=script&lang=js&"
export * from "./onSiteElectricity.vue?vue&type=script&lang=js&"
import style0 from "./onSiteElectricity.vue?vue&type=style&index=0&id=545912d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545912d2",
  null
  
)

export default component.exports